import { Component, Input, OnInit, OnChanges, SimpleChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../core/service/base/his-base-globals.service';
import { HisTranslationService } from '../../translation/service/his-translation.service';
import { Language } from '../model/language';

@Component( {
    selector: 'his-translated-html',
    templateUrl: './his-translated-html.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )

export class HisTranslatedHtmlComponent implements OnInit, OnChanges {
    hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private hisTranslationService = inject(HisTranslationService);

    @Input() hisobject: any;
    @Input() hisAttribute: string;
    @Input() maxLength: number;
    @Input() viewAll: boolean=false;
    translatedText: string='';
    language: string;
    translationEntries: [string, string][]=[];
    hisObjectLanguage: Language;
    hisObjectLanguageI18nKey: string;
    attributeName: string;

    constructor() {
        this.language = this.hisBaseGlobalsService.getLanguage();
    }
    
    ngOnInit(): void {
        
        this.attributeName = this.hisAttribute.split('.').pop();
        if ( !this.isHisObjectEmpty() && this.isPropertyOfObject() ){
            this.translatedText = this.getTranslatedText( this.hisobject, this.attributeName, this.language );
            if(this.viewAll){
                this.readAllTranslations();
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ( changes.hisobject || changes.hisAttribute ) {
            if ( !this.isHisObjectEmpty() && this.hisAttribute ) {
                this.attributeName = this.hisAttribute.split('.').pop();
                if ( this.isPropertyOfObject() ){
                    this.translatedText = this.getTranslatedText( this.hisobject, this.attributeName, this.language );
                    if(this.viewAll){
                        this.readAllTranslations();
                    }
                }
            }
        }
    }
    
    private getTranslatedText( hisobject: any, hisAttribute: string, language: string ) {
        let translatedText = '';

        if ( hisobject[hisAttribute] == null || hisobject[hisAttribute].length === 0 ) {
            console.warn( 'Value of attribute named \'', hisAttribute, '\' in object ',
                hisobject, ' is empty. Will now try to find a foreign text for it.' );
        }

        if ( this.hisTranslationService.isTranslationExisting( hisobject, hisAttribute, language ) ) {
            translatedText = this.hisTranslationService.translate( hisobject, hisAttribute, language );
        }

        if ( translatedText.length === 0 ) {
            if ( hisobject.language ) {
                this.language = hisobject.language.iso_639_1;
            }
            else if ( hisobject.languages && hisobject.languages.length > 0 && hisobject.languages[0] ) {

                this.language = hisobject.languages[0].iso_639_1;
            }
            translatedText = this.hisTranslationService.translate( hisobject, hisAttribute, this.language );
        }

        if ( this.maxLength && translatedText.length > this.maxLength ) {
            return this.shortenText( translatedText );
        }
        else {
            return translatedText;
        }
    }

    
    /* substring text to maxLength or last full word */
    public shortenText( text: string ): string {
        let textLength = this.maxLength;
        while ( ( text.charAt( textLength ) !== ' '
            || text?.charAt( textLength ).match( '\n' ) ) && textLength !== 0 ) {
            textLength--;
        }
        return text.substring( 0, textLength ) + ' ...';
    }

    getLanguage() {
        return this.language;
    }

    private isHisObjectEmpty() {
        if ( this.hisobject == null || Object.values( this.hisobject ).filter( v => !!v ).length === 0 ) {
            console.warn( 'Hisobject is ', this.hisobject );
            return true;
        }
        return false;
    }

    private isPropertyOfObject(){
        if (!this.attributeName) {
            console.warn( 'Attribute is ', this.attributeName );
            return false;
        }
        if ( !Object.prototype.hasOwnProperty.call( this.hisobject, this.attributeName ) ) {
            console.warn( 'No attribute named \'', this.attributeName, '\' present in object ', this.hisobject );
            return false; 
        }
        return true;
    }
    
    private readAllTranslations () {
        let allTanslationsMap: Map<string, string> = new Map<string, string>();

        this.hisObjectLanguage = this.hisobject.language ? this.hisobject.language : ( this.hisobject.languages?.length > 0 ? this.hisobject.languages[0]: null);
        this.hisObjectLanguageI18nKey = 'view.translate.' + this.hisObjectLanguage.iso_639_1 ;

        if ( ( this.language !== this.hisObjectLanguage.iso_639_1 ) && 
             ( this.translatedText?.length>0 ) && 
             ( !allTanslationsMap.has(this.language)) ) {
            allTanslationsMap.set(this.language, this.translatedText);
        }

        for( let lang in this.hisobject._foreigntext ){
            if ( !allTanslationsMap.has(lang) ) {
                let ft = this.hisobject._foreigntext[lang][this.attributeName];
                if( ft?.length>0 ) {
                    allTanslationsMap.set(lang, ft);
                }
            }
        }
        this.translationEntries = Array.from(allTanslationsMap.entries()); 
    }

}
